import { ReactNode, useContext, useEffect } from 'react';
import { UserContext } from 'contexts/user';
import { Elements } from '@stripe/react-stripe-js';
import LayoutV2 from 'components/common/LayoutV2';
import AccountNav from './AccountNav';
import PageLoad from 'components/profile/PageLoad';
import styles from './AccountLayout.module.css';
import { useStripe } from 'contexts/stripeContext';

type Props = {
  tabTitle: string;
  navTitle: string;
  children: ReactNode;
  useBlank?: boolean;
  teamId?: number;
};

const AccountGrid = ({
  tabTitle,
  navTitle,
  children,
  teamId,
  useBlank = false,
}: Props) => {
  const { stripePromise } = useStripe();
  const { user, userLoaded } = useContext(UserContext);
  const options = {
    fonts: [
      {
        cssSrc: 'https://fonts.googleapis.com/css2?family=Inter&display=swap',
      },
    ],
  };

  useEffect(() => {
    if (userLoaded && !user?.signedIn) {
      window.location.assign('/login');
    }
  }, [user, userLoaded]);

  if (userLoaded && user?.signedIn) {
    return (
      <LayoutV2 navTitle={navTitle} title={tabTitle} backgroundColor="#242424">
        <Elements stripe={stripePromise} options={options}>
          {useBlank ? (
            <>{children}</>
          ) : (
            <div className={styles.Grid}>
              <AccountNav teamId={teamId} />
              {children}
            </div>
          )}
        </Elements>
      </LayoutV2>
    );
  }

  return <PageLoad />;
};

export default AccountGrid;

interface AreaProps {
  children?: ReactNode;
}

export const LeadingArea = ({ children }: AreaProps) => (
  <div className={styles.LeadingArea}>{children}</div>
);

interface HeaderProps {
  title: string;
}

export const SectionHeader = ({ title }: HeaderProps) => (
  <LeadingArea>
    <h2>{title}</h2>
  </LeadingArea>
);

export const ContentArea = ({ children }: AreaProps) => (
  <div className={styles.ContentArea}>{children}</div>
);

export const NoMarginContentArea = ({ children }: AreaProps) => (
  <div className={styles.NoMarginContentArea}>{children}</div>
);

export const WideContentArea = ({ children }: AreaProps) => (
  <div className={styles.WideContentArea}>{children}</div>
);

export const TrailingArea = ({ children }: AreaProps) => (
  <div className={styles.TrailingArea}>{children}</div>
);
